import script from "./EvalDatasetsView.vue?vue&type=script&setup=true&lang=js"
export * from "./EvalDatasetsView.vue?vue&type=script&setup=true&lang=js"

import "./EvalDatasetsView.vue?vue&type=style&index=0&id=cfe2c59c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cfe2c59c"]])

export default __exports__